import { styled } from 'styled-components'

import styledMUI from '@mui/system/styled'
import { TextField } from '@mui/material'
import { Link } from 'react-router-dom'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const NavElement = styled.p<{ selected: boolean }>`
  margin-right: 15px;

  display: inline-block;
  cursor: pointer;
  a,
  span {
    font-weight: 600;
    color: #808080;
    text-decoration: none;
  }

  ${({ selected }) =>
    selected &&
    `
    border-bottom: 2px solid #3BAAB0;
    font-weight: 700;
    span, a {
      color: #1A1A1A;
    }
  `}
`
export const LeftSide = styled.div`
  //display: flex;
  //align-items: center;
  > div {
    cursor: pointer;
  }
`
export const RightSide = styled(LeftSide)`
  float: right;
  display: flex;
  height: 32px;
  
  p {
    color: #808080;
  }
`

export const SearchInput = styledMUI(TextField)({
  color: 'var(--text-secondary, #808080)',
  textAlign: 'center',
  fontFamily: 'Roboto',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '20px; /* 142.857% *',
  letterSpacing: ' 0.28px',
  background: 'transparent',
  display: 'flex',
  alignItems: 'flex-start',
  label: {
    top: '10px',
  },
})

export const Filter = styled.button<{ selected?: boolean }>`
  margin-right: 20px;
  padding: 0px;
  background: transparent;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  svg {
    margin-right: 5px;
    fill: ${({ selected }) => (selected ? '#000' : '#808080')};
  }
  p {
    color: ${({ selected }) => (selected ? '#000' : '#808080')};
  }
`

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;

  position: absolute;
  overflow: hidden;
  top: 40px;
  right: 0px;
  max-height: 210px;
  overflow-y: auto;

  align-items: center;
  min-width: 100px;

  border-radius: 4px;
  background-color: #fbfbfb;
  box-shadow: 2px 2px 5px 1px #0008;

  p {
    cursor: pointer;
    padding: 5px;
    margin: 0px;
    :hover {
      background-color: gray;
    }
  }
`

export const SortContainer = styled.div<{ selected?: boolean }>`
  margin-right: 15px;
  margin-left: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  svg {
    margin-right: 5px;
    fill: ${({ selected }) => (selected ? '#000' : '#808080')};
  }
  p {
    font-weight: 600;
    color: ${({ selected }) => (selected ? '#000' : '#808080')};
  }
`
export const CreateIndicator = styled(Link)`
  //text-decoration: none;
  //width: fit-content;
  //height: fit-content;
  //svg {
  //  fill: #fff;
  //}
  //p {
  //  margin: 0;
  //  color: #fff !important;
  //}
  //div {
  //  display: flex;
  //  flex-direction: row;
  //  align-items: center;
  //  justify-content: center;
  //  height: fit-content;
  //  min-width: 200px;
  //  padding: 0px 9px;
  //  border-radius: 3px;
  //  background: #3baab0;
  //}
  //div:hover {
  //  animation: amin 2s infinite;
  //
  //  @keyframes amin {
  //    0% {
  //      background: #3baab0;
  //    }
  //    50% {
  //      background: #6fcdd2;
  //    }
  //    100% {
  //      background: #3baab0;
  //    }
  //  }
  //}
`

export const NavBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  p {
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.28px;
  }
`
export const Table = styled.div`
  width: 100%;
  table {
    width: 100%;
    thead {
      th {
        text-align: start;
      }
    }
    tbody {
      width: 100%;
      td {
        max-width: 25%;
        min-width: 10%;
      }
    }
  }
`

// export const Button = styled.div`
//   display: flex;
//   padding: 10px;
//   border-radius: 100px;
//   border: 1px solid #ededed;
//   background: #f7f7f7;
// `
// export const FlexBlock = styled.div`
//   display: -webkit-box;
//   align-items: flex-start;
//   justify-content: flex-start;
//   flex-wrap: nowrap;
// `
